export default __webpack_public_path__ + "static/media/navBanner.d1662d2d.svg";